import { computed, inject } from '@angular/core';
import { patchState, signalStore, withMethods } from '@ngrx/signals';
import { setAllEntities, withEntities } from '@ngrx/signals/entities';
import { MemberPurchase } from '../models/member-purchase.model';
import { rxMethod } from '@ngrx/signals/rxjs-interop';
import { pipe, switchMap } from 'rxjs';
import { tapResponse } from '@ngrx/operators';
import { PurchaseService } from '../purchase.service';
import { LoggingService } from '../../../shared/services/core/logging.service';

// TODO: Replace with the built-in idKey feature once the NgRx Signals version is upgraded.
const idKey = 'LogId' as const;

export const PurchaseV2Store = signalStore(
  { providedIn: 'root' },
  withEntities<MemberPurchase>(),
  withMethods((store, purchaseService = inject(PurchaseService), loggingService = inject(LoggingService)) => ({
    /* ================================
     * Getters
     * ================================ */

    /** Returns a computed signal of unique purchases filtered by the given OrderId. */
    getPurchasesByOrderId(orderId: string) {
      return computed(() => store.entities().filter((item) => item.OrderId === orderId));
    },
    getUniquePurchasesByOrderId(orderId: string) {
      return computed(() => {
        const purchases = new Set<number>();
        const purchasesByOrderId = this.getPurchasesByOrderId(orderId);
        return purchasesByOrderId().filter((item) => {
          if (purchases.has(item.RewardItemId)) return false;
          purchases.add(item.RewardItemId);
          return true;
        });
      });
    },
    fetchMemberPurchases: rxMethod<void>(
      pipe(
        switchMap(() =>
          purchaseService.fetchMemberPurchasesV2().pipe(
            tapResponse({
              next: (items) => {
                patchState(store, setAllEntities(items, { idKey }));
              },
              error: (error) => {
                loggingService.error('Failed to fetch member purchases', error);
              },
            })
          )
        )
      )
    ),
  }))
);
